import {Router} from '@angular/router';

export class Session {
    public type: string;
    public url: string;

    constructor(
        public idGoogle: number,
        public name: string,
        public imgUrl: string,
        public email: string,
        public id: number,
        public _type: string) {
        this.type = _type;
        this.url = '/' + this.type;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/domain/session.ts